import { motion } from 'framer-motion';
import { buildPublicUrl } from '../../lib/libraryUtils';

const previewGradientByType = {
  video: 'linear-gradient(135deg, #0f172a 0%, #0ea5e9 120%)',
  audio: 'linear-gradient(135deg, #0f172a 0%, #10b981 120%)',
  document: 'linear-gradient(135deg, #0f172a 0%, #f59e0b 120%)',
  other: 'linear-gradient(135deg, #0f172a 0%, #a78bfa 120%)'
};

const cardVariants = {
  hidden: { opacity: 0, y: 20, scale: 0.98 },
  visible: { opacity: 1, y: 0, scale: 1 }
};

export const AssetShelf = ({ title, items, onPreview, typeIcons, typeLabels }) => {
  if (!items || items.length === 0) return null;

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <p className="text-lg font-black text-gray-900">{title}</p>
        <span className="chip">{items.length}</span>
      </div>

      <div className="flex gap-3 overflow-x-auto pb-2">
        {items.map((asset) => {
          const Icon = typeIcons[asset.type];
          const publicUrl = buildPublicUrl(asset.path);

          return (
            <motion.button
              key={asset.id}
              type="button"
              onClick={() => onPreview(asset)}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.35 }}
              variants={cardVariants}
              transition={{ duration: 0.32, ease: 'easeOut' }}
              whileHover={{ y: -6, scale: 1.01 }}
              whileTap={{ scale: 0.99 }}
              className="group text-right min-w-[270px] max-w-[270px] rounded-3xl border border-white/50 bg-white/70 overflow-hidden will-change-transform"
            >
              <div className="h-40 w-full bg-gray-100 overflow-hidden">
                {asset.type === 'video' ? (
                  <video
                    src={publicUrl}
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload="metadata"
                    className="w-full h-full object-cover pointer-events-none transition duration-500 group-hover:scale-105"
                  />
                ) : asset.type === 'image' ? (
                  <img
                    src={publicUrl}
                    alt={asset.displayName || asset.name}
                    className="w-full h-full object-contain bg-gradient-to-br from-slate-50 to-cyan-50 p-2 pointer-events-none transition duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                ) : (
                  <div
                    className="w-full h-full flex flex-col items-center justify-center text-white font-black gap-2"
                    style={{ background: previewGradientByType[asset.type] || previewGradientByType.other }}
                  >
                    <span className="text-base">{typeLabels[asset.type]}</span>
                  </div>
                )}
              </div>

              <div className="p-4 space-y-2">
                <div className="flex items-start justify-between gap-2">
                  <p className="font-black text-gray-900 leading-tight line-clamp-2">{asset.displayName || asset.name}</p>
                  <div className="w-9 h-9 rounded-2xl bg-gray-900 text-white flex items-center justify-center flex-shrink-0">
                    <Icon size={18} weight="fill" />
                  </div>
                </div>

                <p className="text-xs text-gray-700 line-clamp-2">{asset.description}</p>
                <p className="text-xs text-gray-600 truncate">{`المصدر: ${asset.sourceLabel}`}</p>
                <span className="chip">{typeLabels[asset.type]}</span>
              </div>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
};
